var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, ManyToOne, PrimaryColumn, UpdateDateColumn } from 'typeorm';
import { Project } from './project.js';
import { HTTPSnapshot } from './snapshot-web.js';
import { Test } from './test.js';
export var TestRunStatus;
(function (TestRunStatus) {
    TestRunStatus["STARTED"] = "STARTED";
    TestRunStatus["SUCCESS"] = "SUCCESS";
    TestRunStatus["FAILED"] = "FAILED";
    TestRunStatus["BLOCKED"] = "BLOCKED";
    TestRunStatus["SKIPPED"] = "SKIPPED";
    TestRunStatus["UNREACHABLE"] = "UNREACHABLE";
    TestRunStatus["CRASHED"] = "CRASHED";
})(TestRunStatus || (TestRunStatus = {}));
export var TestRunTrigger;
(function (TestRunTrigger) {
    TestRunTrigger["MANUAL"] = "manual";
    TestRunTrigger["SCHEDULED"] = "scheduled";
    TestRunTrigger["RETRY"] = "retry";
    TestRunTrigger["UNKNOWN"] = "unknown";
})(TestRunTrigger || (TestRunTrigger = {}));
let TestRun = class TestRun {
    id;
    createdDate;
    updatedDate;
    startDate;
    finishedDate;
    durationSeconds;
    status;
    errorMessage;
    usedProxy;
    vantagePoint;
    project;
    test;
    snapshot;
    triggerType;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], TestRun.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], TestRun.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], TestRun.prototype, "updatedDate", void 0);
__decorate([
    Column({ type: 'timestamp', nullable: true }),
    Type(() => Date),
    __metadata("design:type", Date)
], TestRun.prototype, "startDate", void 0);
__decorate([
    Column({ type: 'timestamp', nullable: true }),
    Type(() => Date),
    __metadata("design:type", Date)
], TestRun.prototype, "finishedDate", void 0);
__decorate([
    Column({ type: 'float', nullable: true }),
    __metadata("design:type", Number)
], TestRun.prototype, "durationSeconds", void 0);
__decorate([
    Column({ type: 'enum', enum: TestRunStatus, default: TestRunStatus.STARTED }),
    __metadata("design:type", String)
], TestRun.prototype, "status", void 0);
__decorate([
    Column({ type: 'varchar', nullable: true }),
    __metadata("design:type", Object)
], TestRun.prototype, "errorMessage", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TestRun.prototype, "usedProxy", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", String)
], TestRun.prototype, "vantagePoint", void 0);
__decorate([
    ManyToOne(() => Project, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Project)
], TestRun.prototype, "project", void 0);
__decorate([
    ManyToOne(() => Test, (test) => test.runs, { nullable: false, onDelete: 'CASCADE' }),
    __metadata("design:type", Test)
], TestRun.prototype, "test", void 0);
__decorate([
    ManyToOne(() => HTTPSnapshot, { nullable: true, createForeignKeyConstraints: false }),
    __metadata("design:type", HTTPSnapshot)
], TestRun.prototype, "snapshot", void 0);
__decorate([
    Column({ type: 'enum', enum: TestRunTrigger, default: TestRunTrigger.UNKNOWN }),
    __metadata("design:type", String)
], TestRun.prototype, "triggerType", void 0);
TestRun = __decorate([
    Index('idx_tr_status', ['status']),
    Index('idx_tr_project', ['project']),
    Index('idx_tr_test', ['test']),
    Index('idx_tr_trigger', ['triggerType']),
    Index('idx_tr_created_date', ['createdDate']),
    Entity(),
    Index(['test', 'createdDate'])
], TestRun);
export { TestRun };
//# sourceMappingURL=data:application/json;base64,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